import React from 'react';

import { Flex } from '@chakra-ui/react';

const Accidents = () => <Flex>Accidents</Flex>;

export default Accidents;
